import React from "react";
import ReactDOM from "react-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.scss";
import { App } from "./App";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import ScrollToTop from "react-router-scroll-top";
import NoMatch from "./components/NoMatch/NoMatch";
import { Provider } from "react-redux";
import store from "./context/store";
import { MatomoProvider, createInstance } from "@datapunt/matomo-tracker-react";
import config from "./config/app/config";

let instance = null;

if (process.env.REACT_APP_ENV === "prod") {
  instance = createInstance({
    urlBase: config["client-host"],
    siteId: config["site-id"],
    trackerUrl: `${config["matomo-host"]}/matomo.php`,
    srcUrl: `${config["matomo-host"]}/matomo.js`,
    linkTracking: true,
  });
}

ReactDOM.render(
  <MatomoProvider value={instance}>
    <Router onUpdate={() => window.scrollTo(0, 0)} basename='webapp'>
      <ScrollToTop>
        <Switch>
          <Route exact path="/:hash/ups" component={NoMatch} />
          <Provider store={store}>
            <Route path="/:hash" component={App} />
          </Provider>
        </Switch>
      </ScrollToTop>
    </Router>
  </MatomoProvider>,
  document.getElementById("root")
);
